<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <rect id="Rectangle_55" data-name="Rectangle 55" width="24" height="24" fill="none"/>
    <path id="Path_29" data-name="Path 29" d="M14.59,7.41,18.17,11H6v2H18.17l-3.59,3.59L16,18l6-6L16,6ZM2,6V18H4V6Z"/>
</svg>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "lodgeicon"
})
</script>